// extracted by mini-css-extract-plugin
export default {"searchContainer":"searchContainer-SybB6","matchValue":"matchValue-vy2no"};